<template>
  <div>
    <b-row>
      <b-col cols="8" offset="2">
        <b-form-group label-for="operator-input" class="mb-3">
          <OperatorSelector v-model="operator" :operators="this.groupedOperators" v-validate="{ required: true }"
            :state="validateState('operator-input')" data-vv-name="operator-input" data-vv-as="Operator" />
          <b-form-invalid-feedback>
            {{ veeErrors.first('operator-input') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="8" offset="2">
        <b-button @click="handleExport" variant="primary" :disabled="isLoading">
          Export
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import OperatorSelector from './OperatorSelector.vue'

export default {
  components: {
    OperatorSelector
  },
  data() {
    return {
      operator: null,
      operatorOptions: [],
      isLoading: false,
      isProcessingImport: false,
      rewrite: false,
      opened: true,
      file: null,
    }
  },
  computed: {
    groupedOperators() {
      const grouped = this.operatorOptions.reduce((acc, operator) => {
        const partner = operator.partner || 'Other'
        if (!acc[partner]) {
          acc[partner] = {
            partner,
            operators: []
          }
        }
        acc[partner].operators.push({
          id: operator.id,
          name: operator.name
        })
        return acc
      }, {})
      return grouped
    }
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    handleExport() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        if (this.isLoading) {
          return;
        }

        this.isLoading = true;

        this
          .$http({
            url: '/api/v1/limits/export/' + this.operator,
            method: 'GET',
            responseType: 'blob'
          })
          .then(response => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            const operator = this.operatorOptions.find(({ id }) => id === this.operator);
            fileLink.setAttribute('download', operator.name + '.zip');
            document.body.appendChild(fileLink);
            fileLink.click();
          })
          .catch((err) => {
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));

            throw err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    onShow() { },
    onHidden() {
      this.$emit('close');
    },
  },
  async beforeMount() {
    await this.$store.dispatch('operatorsForSelect/loadList').then(() => {
      this.operatorOptions = this.$store.getters['operatorsForSelect/list'].map(({ label, value }) => {
        return { id: value, name: label, checked: false }
      });
    });
  },
}
</script>
